import { render, staticRenderFns } from "./geonotificationshistory.vue?vue&type=template&id=677753e0&scoped=true"
import script from "./geonotificationshistory.vue?vue&type=script&lang=js"
export * from "./geonotificationshistory.vue?vue&type=script&lang=js"
import style0 from "./geonotificationshistory.vue?vue&type=style&index=0&id=677753e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677753e0",
  null
  
)

export default component.exports